module.exports = __webpack_public_path__ + "static/mobile-virtual-bg-8cd9d997b77b5480321e68115e80a8d4.png";